module.exports = __webpack_public_path__ + "static/img/img47.0dfe62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img47.png
// module id = oEeM
// module chunks = 1